/* eslint-disable react/no-unknown-property */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState, useEffect } from 'react';
import {
  Modal, Select, Form, notification, Spin, Input, Tooltip
} from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, ReloadOutlined } from '@ant-design/icons';
// import { getUsers } from '../services/teamMembers';
import * as constants from '../../utils/constants';

const { Option } = Select;

const ResetPasswordModal = (props) => {
  const {
    setTeamModalLoading,
    teamModalLoading, resetPasswordModalVisible, setResetPasswordModalVisible, resetPasswordForm,
    resetPasswordModalLoading, setResetPasswordModalLoading, onResetPassword, resetPasswordRecord, setResetPasswordRecord
  } = props;
  const [selectedValue, setSelectedValue] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [newPwdFocused, setNewPwdFocused] = React.useState(false);
  const [confirmPwdFocused, setConfirmPwdFocused] = React.useState(false);
  const [showToolTip, setShowToolTip] = useState(true);
  const [passwordStrength, setPasswordStrength] = useState({ score: 0 });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handlePassword = (e) => {
    const password = e.target.value;
    const regexPattern = /^(?=.*[-\#\$\.\%\&\@\!\+\=\\*])(?=.*[a-zA-Z])(?=.*\d).{8,12}$/;
    if (password.match(regexPattern)) {
      setShowToolTip(false);
    } else { setShowToolTip(true); }
    setPasswordStrength({ score: evaluatePasswordStrength(password) });
  };

  const handleCancel = () => {
    setResetPasswordRecord([]);
    resetPasswordForm.resetFields();
    setResetPasswordModalVisible(false);
  };

  const evaluatePasswordStrength = (password) => {
    let score = 0;
    if (!password) return 0;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[-#$.%&@!+=\\*]/.test(password)) score++;
    return score; // 0 to 5
  };

  const handleGeneratePassword = () => {
    const pwd = generateRandomPassword();
    console.log('pwd', pwd);
    resetPasswordForm.setFieldsValue({
      password: pwd,
      password_confirm: pwd,
    });
    setShowToolTip(false);
    setPasswordStrength({ score: evaluatePasswordStrength(pwd) });
    // Show the first password field when generated
    setShowNewPassword(true);
  };

  const generateRandomPassword = () => {
    const length = 10; // Always 8 characters
    const specials = '-#$.%&@!+=\\*';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';
    const all = specials + lower + upper + numbers;

    let password = [
      specials[Math.floor(Math.random() * specials.length)],
      lower[Math.floor(Math.random() * lower.length)],
      upper[Math.floor(Math.random() * upper.length)],
      numbers[Math.floor(Math.random() * numbers.length)],
    ];

    for (let i = password.length; i < length; i++) {
      password.push(all[Math.floor(Math.random() * all.length)]);
    }
    // Shuffle password
    password = password.sort(() => Math.random() - 0.5).join('');
    return password;
  };

  useEffect(() => {
    resetPasswordForm.setFieldsValue({
      fullName: resetPasswordRecord.email,
    });
  }, [resetPasswordRecord]);

  const changeTempPass = async (data) => {
    try {
      if (data.password === data.password_confirm) {
        const postData = {
          password: data.password,
          email: resetPasswordRecord.email.toLowerCase(),
          userName: resetPasswordRecord.user_id
        }
        setResetPasswordModalLoading(true);
        await onResetPassword(postData);
      } else {
        notification.warning({
          message: 'Passwords do not match',
        });
      }
    } catch (err) {
      notification.warning({
        message: 'Something went wrong.',
      });
    }
  };

  const validatePass = () => {
    resetPasswordForm
      .validateFields()
      .then(async (data) => {
        await changeTempPass(data);
      });
  };



  return (

    <Modal
      className="quality-modal"
      title="Reset Password"
      centered
      visible={resetPasswordModalVisible}
      onOk={() => validatePass()}
      okText="Reset Password"
      onCancel={() => handleCancel(false)}
      okButtonProps={{ disabled: resetPasswordModalLoading }}
      cancelButtonProps={{ disabled: resetPasswordModalLoading }}
    >
      <div className="signup-form">
          <Form
            name="normal_login"
            initialValues={{
              remember: true,
            }}
            form={resetPasswordForm}
          >

          <Form.Item name="fullName" >
            <Input
              className="select-dropdown-signup"
              placeholder="User Email"
              disabled
            />
          </Form.Item>
            <Tooltip
              visible={newPwdFocused && showToolTip}
              title={(
                <>
                  <p align="left"><b>Requirements:</b></p>
                  <ul align="left">
                    <li align="left">8-character minimum length</li>
                    <li align="left">Contains at least 1 number</li>
                    <li align="left">Contains at least 1 lowercase letter</li>
                    <li align="left">Contains at least 1 uppercase letter</li>
                    <li align="left">Contains at least 1 special character from the following set, or a non-leading, non-trailing space character.</li>
                    <p align="left">{'^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < \' : ; | _ ~ ` + ='}</p>
                  </ul>

                </>
              )}
              placement="topLeft"
            >
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Please enter New Password.',
                  },
                  {
                    pattern: true
                      ? constants.PASSWORD_VALIDATION
                      : undefined,
                    message: 'Password does not meet password policy rules',
                  }
                ]}
              >
                {showNewPassword ? (
                  <Input
                    size="large"
                    className="password-icon"
                    placeholder="New Password"
                    suffix={
                      <span style={{ display: 'flex', alignItems: 'center' }}>
                        <EyeOutlined 
                          style={{ color: 'grey', cursor: 'pointer' }} 
                          onClick={() => setShowNewPassword(false)}
                        />
                        <ReloadOutlined
                          style={{ color: 'grey', marginLeft: 8, cursor: 'pointer' }}
                          onClick={handleGeneratePassword}
                          title="Generate random password"
                        />
                      </span>
                    }
                    onFocus={() => setNewPwdFocused(true)}
                    onBlur={() => setNewPwdFocused(false)}
                    onChange={(e) => handlePassword(e)}
                  />
                ) : (
                  <Input.Password
                    size="large"
                    className="password-icon"
                    placeholder="New Password"
                    iconRender={(visibility) =>
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                          {visibility ? <EyeOutlined style={{ color: 'grey' }} /> : <EyeInvisibleOutlined style={{ color: 'grey' }} />}
                          <ReloadOutlined
                            style={{ color: 'grey', marginLeft: 8, cursor: 'pointer' }}
                            onClick={handleGeneratePassword}
                            title="Generate random password"
                          />
                        </span>
                    }
                    onFocus={() => setNewPwdFocused(true)}
                    onBlur={() => setNewPwdFocused(false)}
                    onChange={(e) => handlePassword(e)}
                  />
                )}
              </Form.Item>
            </Tooltip>
            <Tooltip
              visible={confirmPwdFocused && showToolTip}
              title={(
                <>
                  <p align="left"><b>Requirements:</b></p>
                  <ul align="left">
                    <li align="left">8-character minimum length</li>
                    <li align="left">Contains at least 1 number</li>
                    <li align="left">Contains at least 1 lowercase letter</li>
                    <li align="left">Contains at least 1 uppercase letter</li>
                    <li align="left">Contains at least 1 special character from the following set, or a non-leading, non-trailing space character.</li>
                    <p align="left">{'^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < \' : ; | _ ~ ` + ='}</p>
                  </ul>

                </>
              )}
              placement="topLeft"

            >
              <Form.Item
                name="password_confirm"
                rules={[
                  {
                    required: true,
                    message: 'Please confirm your password.',
                  },
                  {
                    pattern: true
                      ? constants.PASSWORD_VALIDATION
                      : undefined,
                    message: 'Password does not meet password policy rules',
                  }
                ]}
              >
                <Input.Password
                  size="large"
                  className="password-icon"
                  placeholder="Confirm New Password"
                  iconRender={(visibility) => (visibility ? <EyeOutlined style={{ color: 'grey' }} /> : <EyeInvisibleOutlined style={{ color: 'grey' }} />)}
                  onFocus={() => setConfirmPwdFocused(true)}
                  onBlur={() => setConfirmPwdFocused(false)}
                  onChange={(e) => handlePassword(e)}
                />
              </Form.Item>
                {/* Dotted password strength meter */}
                <div style={{ marginBottom: 18, display: 'flex', alignItems: 'center', marginTop: 8 }}>
                    {[1, 2, 3, 4, 5].map((dot) => (
                      <span
                        key={dot}
                        style={{
                          display: 'inline-block',
                          width: 10,
                          height: 10,
                          borderRadius: '50%',
                          marginRight: 4,
                          background: passwordStrength.score >= dot
                            ? passwordStrength.score <= 2
                              ? '#ff4d4f' // weak = red
                              : passwordStrength.score === 3 || passwordStrength.score === 4
                                ? '#faad14' // medium = orange
                                : '#52c41a' // strong = green
                            : '#e0e0e0', // empty = gray
                          transition: 'background 0.3s'
                        }}
                      />
                    ))}
                    <span style={{
                      marginLeft: 8, color:
                        passwordStrength.score <= 2
                          ? '#ff4d4f'
                          : passwordStrength.score <= 4
                            ? '#faad14'
                            : '#52c41a',
                      fontWeight: 500
                    }}>
                      {passwordStrength.score === 0 ? '' : passwordStrength.score <= 2 ? 'Weak' : passwordStrength.score <= 4 ? 'Medium' : 'Strong'}
                    </span>
                  </div>
            </Tooltip>
        </Form>
      </div>
    </Modal>

  );
};

export default ResetPasswordModal;
